import Vue from 'vue'
import {Message} from 'view-design'
import {API_COMM_REGISTER, API_COMM_LOGIN, API_COMM_RESET} from "@/constant/api";
import request from '@/utils/request';
export function loginApi(data) {
  // return new Promise((resolve, reject) => {
  //   setTimeout(() => {
  //       Message.success({
  //           background: true,
  //           content: '登录成功'
  //       });
  //       resolve({
  //         id: 1,
  //         name:'小张'
  //       })
  //   },300)
  // })
  console.log('开始登录',data)
  return new Promise((resolve, reject) => {
    request(API_COMM_LOGIN, {
      uid: data.uid,
      upass: data.upass,
    }, {
      method: 'POST'
    })
      .then((res) => {
        Message.success({
          background: true,
          content: '登录成功'
        });
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

// signup
export function registerApi(data) {
  // return new Promise((resolve, reject) => {
  //   setTimeout(() => {
  //       console.log('tag', Vue.prototype)
  //       Message['success']({
  //           background: true,
  //           content: '注册成功'
  //       });
  //       resolve(0)
  //   },300)
  // })
  console.log('开始注册',data)
  return new Promise((resolve, reject) => {
    request(API_COMM_REGISTER, {
      uid: data.uid,
      upass: data.upass,
      user_addr: data.user_addr
    }, {
      method: 'POST'
    })
      .then((res) => {
        Message.success({
          background: true,
          content: '注册成功，已发送邮箱验证链接，请注意查收'
        });
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}


export  function  resetApi(data) {
  return new Promise((resolve, reject) => {
    request(API_COMM_RESET, {
      uid: data.uid,
      upass: data.upass
    }, {
      method: 'POST'
    })
      .then((res) => {
        Message.success({
          background: true,
          content: '已发送邮箱验证链接，请前往校验'
        });
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}



// WEBPACK FOOTER //
// ./src/api/user.js